//@ts-check

/**
 * @type {import("./types").getStringBetweenParentheses}
 */
// for optimization purpuses have the regex in constant variable
var getStringBetweenParentheses = function getStringBetweenParentheses(value) {
  var regExp = /\(([^)]+)\)/;
  var matches = regExp.exec(value);
  return matches[1];
};

export default getStringBetweenParentheses;